import React from "react";
import { observer } from "mobx-react";
import className from "../../../shared/className";
import "./PatientList.scss";
import PatientListHead from "./PatientListsHead";
import PatientListItem from "./PatientListItem";
import Loader from "../../../shared/Loader";

class PatientList extends React.Component {
  constructor(props) {
    super(props);
    this.PatientListItem = this.props.ListItem || PatientListItem;
  }

  // TODO: pass patients as prop.
  get patients() {
    return this.props.surveilStore.patients;
  }

  //TODO: Return patients with a callback from props
  set patients(patients) {
    this.props.surveilStore.customSortedPatients = patients;
  }

  render() {
    return (
      <div
        {...className({
          "patient-list": 1,
          component: 1,
          show: this.props.show,
        })}
      >
        <PatientListHead surveilStore={this.props.surveilStore} />
        <div className="patient-list-items">
          {this.props.surveilStore.loading ? (
            <Loader />
          ) : (
            this.patients.map((patient, i) => {
              const specifics =
                this.props.surveilStore.moduleSpecifics(patient);
              return (
                <PatientListItem
                  patient={patient}
                  specifics={specifics}
                  surveilStore={this.props.surveilStore}
                  dragStart={this.dragStart}
                  onDragEnd={this.props.onDragEnd}
                  dragEnter={this.dragEnter}
                  onDrop={this.onDrop}
                  draggedPatient={this.draggedPatient}
                  i={i}
                  key={patient.asmpid}
                  module={this.props.module}
                />
              );
            })
          )}

          <div ref={(el) => (this.emptyDiv = el)} />
        </div>
      </div>
    );
  }

  dragStart = (patient) => {
    this.originalPatientList = [...this.patients];
    this.draggedPatient = patient;
  };

  dragEnter = (patient) => {
    if (!this.originalPatientList) return;

    const ogPatients = this.originalPatientList;

    if (this.draggedPatient === patient) {
      return (this.patients = this.originalPatientList);
    }

    this.originalPatientList = this.patients = reorderPatients(
      ogPatients,
      patient,
      this.draggedPatient,
    );

    this.props.surveilStore.customSort = true;
    if (this.props.onResort) {
      requestAnimationFrame(() => {
        this.props.onResort();
      });
    }
  };

  onDrop = (e) => {
    e.dataTransfer.setDragImage(this.emptyDiv, 0, 0);
    this.draggedPatient = null;
  };
}

export default observer(PatientList);

export const reorderPatients = (ogPatients, patient, draggedPatient) => {
  const reorderedPatients = ogPatients.filter(
    (p) => p.asmpid !== draggedPatient.asmpid,
  );
  const targetIndex = ogPatients.indexOf(patient);
  const sourceIndex = ogPatients.indexOf(draggedPatient);

  if (targetIndex < sourceIndex) {
    // dragging up list
    reorderedPatients.splice(targetIndex, 0, draggedPatient);
  } else {
    // targetIndex > sourceIndex (dragging down list)
    reorderedPatients.splice(targetIndex, 0, draggedPatient);
  }

  return reorderedPatients;
};
